import './air-pollution.scss';


document.addEventListener("DOMContentLoaded", function() {
    const legends = document.querySelectorAll(".regions__legend");
    const regions = document.querySelectorAll(".region");
    const mapAreas = document.querySelectorAll('.canada-map-area');

    legends.forEach(legend => {
        legend.addEventListener("click", function() {

            const selectedName = this.dataset.name;

            // Show the selected map area
            const selectedArea = document.querySelector(`#canada-map-area-${selectedName}`);
            // Hide all map areas
            mapAreas.forEach(area => {
                area.classList.remove("active");
            });
            if (selectedArea) {
                selectedArea.classList.add("active");
            }

            // Remove active class from all regions
            regions.forEach(region => region.classList.remove("active"));
            // Add active class to the selected region
            const selectedRegion = document.querySelector(`.region[data-name="${selectedName}"]`);
            if (selectedRegion) {
                selectedRegion.classList.add("active");
            }

            // Remove/show active class in legend
            legends.forEach(legend => legend.classList.remove("active"));
            legend.classList.add("active");

        });
    });



    
});
